import { API, BlockAPI, BlockToolConstructable, BlockToolData, BlockTuneConstructable, InlineToolConstructable, PasteEvent, ToolConfig } from '@editorjs/editorjs';
import { BlockTuneData } from '@editorjs/editorjs/types/block-tunes/block-tune-data';
import { App, AppContext, h, render } from 'vue';

export type InlineToolOptions = {
  api: null | API
  config: null | any
  range: null | Range
}
export default class Wrapper {
  static _context: AppContext
  static install (app: App) {
    Wrapper._context = app._context
  }
  static wrapInlineTool (tool: any) {
    const vnode = h(tool)
    vnode.appContext = Wrapper._context
    const container = document.createElement('div')
    render(vnode, container)
    console.log(vnode.component?.exposed)
    const exposed = vnode.component!.exposed as any
    const el = container.firstElementChild as HTMLElement
    return class InlineTool {
      static get sanitize () {
        return exposed.sanitize && exposed.sanitize()
      }

      static get isInline () {
        return true;
      }

      constructor({ api, config }: { api: API, config: ToolConfig }) {
        exposed.constructor && exposed.constructor({ api, config })
      }

      shortcut () {
        return exposed.shortcut && exposed.shortcut()
      }

      render () {
        return el
      }

      async surround (range: Range) {
        return exposed.surround && exposed.surround(range)
      }

      checkState (range: Range) {
        return exposed.checkState && exposed.checkState(range)
      }

      clear () {
        return exposed.clear && exposed.clear()
      }
    } as InlineToolConstructable
  }
  // BlockTool
  static wrapBlockTool (tool: any) {
    const vnode = h(tool)
    vnode.appContext = Wrapper._context
    const container = document.createElement('div')
    render(vnode, container)
    console.log(vnode.component?.exposed)
    const exposed = vnode.component!.exposed as any
    const el = container.firstElementChild as HTMLElement
    return class BlockTool {
      constructor(options: {
        api: API
        data: BlockToolData
        config?: ToolConfig
        block?: BlockAPI
        readOnly: boolean
      }) {
        exposed.constructor && exposed.constructor(options)
      }
      render () {
        return el
      }
      renderSettings () {
        return el
      }
      save (block: HTMLElement) {
        return {}
      }
      validate (blockData: BlockToolData) {
        return true
      }
      merge (blockData: BlockToolData) {

      }
      pasteConfig () {

      }
      onPaste (event: PasteEvent) {

      }
      destroy () {

      }
      toolbox () {

      }
    }
  }
  static wrapTuneTool (tool: any) {
    const vnode = h(tool)
    vnode.appContext = Wrapper._context
    const container = document.createElement('div')
    render(vnode, container)
    console.log(vnode.component?.exposed)
    const exposed = vnode.component!.exposed as any
    const el = container.firstElementChild as HTMLElement
    return class TuneTool {
      static get isTune () {
        return true;
      }
      constructor({ api, config, block, data }: { api: API, config: ToolConfig, data: BlockTuneData, block: BlockAPI }) {
        exposed.constructor && exposed.constructor({ api, config })
      }
      render () {
        return el
      }
      wrap (blockContent: HTMLElement) {
        return blockContent
      }
      save () {
        exposed.save && exposed.save()
      }
      prepare () {
        exposed.prepare && exposed.prepare()
      }
      reset () {
        exposed.reset && exposed.reset()
      }
    } as BlockTuneConstructable
  }
}